import React from 'react';
import Icon from 'components/AppIcon';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, role }) => {
  if (!isOpen || !role) return null;

  const hasAssignedUsers = role.userCount > 0;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="flex items-center gap-3 p-6 border-b border-secondary-200">
          <div className="w-10 h-10 bg-error-100 rounded-full flex items-center justify-center">
            <Icon name="AlertTriangle" size={20} className="text-error" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-text-primary">Delete Role</h2>
            <p className="text-sm text-text-secondary">This action cannot be undone</p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-4">
            <p className="text-text-primary mb-2">
              Are you sure you want to delete the role <strong>"{role.name}"</strong>?
            </p>
            
            {hasAssignedUsers && (
              <div className="bg-warning-50 border border-warning-200 rounded-md p-3 mb-4">
                <div className="flex items-start gap-2">
                  <Icon name="AlertCircle" size={16} className="text-warning mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-warning-700">
                      Warning: Users Currently Assigned
                    </p>
                    <p className="text-xs text-warning-600 mt-1">
                      This role is currently assigned to {role.userCount} user{role.userCount !== 1 ? 's' : ''}. 
                      Deleting this role will remove their permissions.
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="bg-secondary-50 rounded-md p-3">
              <h4 className="font-medium text-text-primary mb-2">Role Details:</h4>
              <ul className="text-sm text-text-secondary space-y-1">
                <li>• Name: {role.name}</li>
                <li>• Description: {role.description}</li>
                <li>• Assigned Users: {role.userCount}</li>
                <li>• Permission Count: {Object.values(role.permissions).reduce((count, module) => 
                  count + Object.values(module).filter(Boolean).length, 0
                )}</li>
              </ul>
            </div>
          </div>

          {hasAssignedUsers && (
            <div className="mb-4">
              <label className="flex items-start gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  className="mt-1"
                  required
                />
                <span className="text-sm text-text-secondary">
                  I understand that deleting this role will affect {role.userCount} user{role.userCount !== 1 ? 's' : ''} 
                  and their access permissions will be removed.
                </span>
              </label>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end gap-3 p-6 pt-0">
          <button
            onClick={onClose}
            className="
              px-4 py-2 border border-secondary-300 text-text-primary rounded-md font-medium
              hover:bg-secondary-50 transition-colors duration-150
            "
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="
              px-4 py-2 bg-error text-white rounded-md font-medium
              hover:bg-error-600 transition-colors duration-150 hover-lift
              focus:outline-none focus:ring-2 focus:ring-error/20
              flex items-center gap-2
            "
          >
            <Icon name="Trash2" size={16} />
            Delete Role
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;